import { render } from "./PremiumPackage.vue?vue&type=template&id=30f62ec9&scoped=true"
import script from "./PremiumPackage.vue?vue&type=script&lang=js"
export * from "./PremiumPackage.vue?vue&type=script&lang=js"

import "./PremiumPackage.vue?vue&type=style&index=0&id=30f62ec9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-30f62ec9"

export default script